module.exports = __webpack_public_path__ + "static/img/pic_04@2x.b8598e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic_04@2x.png
// module id = EVUV
// module chunks = 2